/*
* The Component Has the Navigation Drawer and Content Panel.
* The Content Panel Loads Relevant page used on URL.
*/
import React                  from 'react';
//import PropTypes from 'prop-types';
import {NavigationDrawer}     from 'react-md'
import { withRouter } from 'react-router-dom'

//Local Imports
import UserProfile            from '../components/UserProfile';
import ContentPanel           from '../components/ContentPanel';
import NavLink                from '../components/NavLink';
import Properties             from '../components/Properties';
import ESComponentWrapper     from '../components/ESComponentWrapper';
import Login                  from '../components/Login';
import FormLogin              from '../components/FormLogin';
import {NotificationContainer} from 'react-notifications';
import ActivatePage from '../pages/Activate'; 
import ChangePasswordPage from '../pages/ChangePassword';

import { AppProperties } from '../common/functions';

//CSS Imports
import 'react-notifications/lib/notifications.css';
import '../css/App.css';
import globalLog from '../components/globalLog';
import CodeForm from '../components/CodeForm';
import RequestCodeForm from '../components/RequestCodeForm';
import ApiRequestService from '../components/ApiRequestService';
import SFAuth from '../SF/SFPages/SFAuth/SFAuthOld';

let navItems = [
  /* {
    exact: true,
    label: 'Assignments',
    to: '/',
  }, */
/* {
  exact: true,
  label: 'Performance Analytics',
  to: '/PerfGraphs',
}, */
{
  exact: true,
  label: 'Performance & Practice',
  to: '/PerfGraphsV2',
},
{
  exact: true,
  label: 'Dashboard',
  to: '/dashboard',
},
{
    exact: true,
    label: 'Settings',
    to: '/settings',
},
/* {
    exact: true,
    label: 'Profile',
    to: '/profile',
}, */
{
  exact: true,
  label: 'Technical troubleshooting',
  to: '/troubleShooting',
},
{
  exact: true,
  label: 'About',
  to: '/about',
},
{
  exact: true,
  label: 'FAQ',
  to: '/FAQ',
}


];



class App extends React.Component {
  
  appProperties = AppProperties();
  
  constructor(props){
    super(props);
    console.debug("this.appProperties.isLTIStudent", this.appProperties.isLTIStudent)

    const updatedNavItems = navItems.map(item => item.label === 'Settings' ? [
      item,
      {
        exact: true,
        label: 'Profile',
        to: '/profile',
      }
    ] : item).flat();

    console.debug("updatedNavItems", updatedNavItems);

    this.state={
      navItems:!this.appProperties.isLTIStudent ? [{
        exact: true,
        label: 'Assignments',
        to: '/',
      },
      ...updatedNavItems, ] : navItems,
      // navItems: navItems
    }

    const originalConsoleLog = console.log;

    console.log = function() {
      let log = ''
      for (var i = 0; i < arguments.length; i++) {
        try {
          log += JSON.stringify(arguments[i])  
        } catch (error) {
          originalConsoleLog(error)
        }
      }
      //If log is greater than 200Kb then clear it out and then append
      if (globalLog.value.length > 200000) {  
        globalLog.value = ''
      }
      globalLog.value += log + '\n'

      originalConsoleLog(...arguments);
    }
  }

  UNSAFE_componentWillMount()
  {
   
  }

  CheckIfThisStudentsCourseSectionEnabled() {
    /* ApiRequestService({
      method: 'get',
      url: '/getStudentCourseSectionPracticeEnabled',
    }).then(res => {
      console.debug("res ==========", res);
      if (res && res.data) {

        if (!res.data.data) {// show the pp page
          let updatedNavItems = this.state.navItems?.filter(item => item.to !== "/PerfGraphsV2")
          console.debug("updatedNavItems", updatedNavItems)
          this.setState({
            navItems: updatedNavItems
          })
        }
      }
    }); */
  }

  componentDidMount() {
    // Change tab title and icon only if it's SF
    if (this.appProperties?.isLTIStudent === false) {
      document.title = "Stem Fluency";
    
      const favIconLink = document.querySelector('link[rel="shortcut icon"]');
      favIconLink.href = './sf-favicon.ico';
    }
    // Hide the P&P page based on course section enabled assignment practice
    this.CheckIfThisStudentsCourseSectionEnabled()
  }

  updateQuizURL = (quizURL) => {
    if(this.appProperties.isLTIStudent){
      this.setState({navItems:[{
        exact: true,
        label: 'Back to Quiz',
        to: quizURL,
      },...navItems]})
    } 
  }

  render() {

    
    //Account Activation Logiv
    const {location} = this.props.history;
    const Activate = ESComponentWrapper(ActivatePage);
    if((location && location.pathname && location.pathname.includes('/activate'))){
      return <Activate history={this.props.history}></Activate>
    }
    const ChangePassword = ESComponentWrapper(ChangePasswordPage);
    if((location && location.pathname && location.pathname.includes('/change-password'))){
      return <ChangePassword history={this.props.history}></ChangePassword>
    }
    const CodeFormPage = ESComponentWrapper(CodeForm);
    if((location && location.pathname && location.pathname.includes('/password-code'))){
      return <CodeFormPage history={this.props.history}></CodeFormPage>
    }
    
    if((location && location.pathname && location.pathname.includes('/activation-code'))){
      return <CodeFormPage history={this.props.history}></CodeFormPage>
    }
    const RequestCodeFormPage = ESComponentWrapper(RequestCodeForm)
    if((location && location.pathname && location.pathname.includes('/request-code'))){
      return <RequestCodeFormPage history={this.props.history}></RequestCodeFormPage>
    }

    //Redirect to Login Screen if The User Profile is Empty
    if(this.appProperties.currentUserData.hasValidData()!== true)
    {
      let LoginPage;
      if(this.appProperties.loginType === 'form'){
        LoginPage = ESComponentWrapper(SFAuth);
      }else{
        LoginPage= ESComponentWrapper(Login);
      }
      
      return <LoginPage history={this.props.history}></LoginPage>
    }


    const Footer = (<footer style={{textAlign:"center",bottom: "0px",width: "100%"}}>
     {this.appProperties.copyright?
      <p><span role="img" aria-label="copyRight">©️ </span> 2020 The Ohio State University All rights reserved.</p>
      :
      <p></p>}
    </footer>);

    return (
      <div>
      <NavigationDrawer

      drawerTitle={<UserProfile 
      loginType={this.appProperties.loginType} 
      givenName={this.appProperties.currentUserData.GivenName} 
      userRole={this.appProperties.currentUserData.role}
      eqmMode={this.appProperties.eqmMode}/>}
    
      navItems={this.state.navItems.map(props => <NavLink {...props} key={props.to} />)}
      navStyle={{backgroundColor: 'white',
      // paddingTop: '85px',
      fontSize: '17px',
      fontFamily: 'Roboto'}}
      desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
      tabletDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
      includeDrawerHeader={true}
      navClassName="navListStyle"
      toolbarClassName="toolbarHeader"
      >
          <ContentPanel history={this.props.history} className="content noMarigin" updateQuizURL={this.updateQuizURL}/>
          <NotificationContainer/>
      </NavigationDrawer>
      {Footer}
      </div>
    );
  }
}

export default withRouter(App);
